import { defaultTranslation, translationsList } from '../../sources';
import { DEFAULT_LOCALE } from '../../constants';
import { getTranslationsFileName } from '../getTranslationsFileName';
const mergeTranslations = (targetTranslations, fallbackTranslations) => {
    return {
        ...fallbackTranslations,
        ...targetTranslations,
    };
};
/**
 * Asynchronously loads translations for the given locale.
 * Non-default translations are merged with the default translations to provide fallback values.
 * If the locale is not found, the default translations are returned.
 * If an error occurs, the default translations are returned.
 * @param locale - The locale to load translations for.
 * @returns The translations for the given locale.
 */
export const loadTranslations = async (locale) => {
    const translationsFileName = getTranslationsFileName(locale);
    if (translationsFileName !== DEFAULT_LOCALE) {
        const getTranslations = translationsList[translationsFileName];
        if (getTranslations !== undefined) {
            try {
                /**
                 * Native ESM resolves `import('./locale.json')` to a namespace object
                 * `{ default: <jsonContents>, ... }`. Webpack/Jest (CJS interop) flatten
                 * the JSON to the top level. Support both shapes so the same loader
                 * works under Vitest/native ESM and under existing CJS bundlers.
                 */
                const mod = (await getTranslations());
                const translations = (mod.default ?? mod);
                return {
                    messages: mergeTranslations(translations, defaultTranslation),
                    loadedLocale: locale,
                };
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    return {
        messages: defaultTranslation,
        loadedLocale: DEFAULT_LOCALE,
    };
};
//# sourceMappingURL=loadTranslations.js.map